import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { DataService } from 'src/app/data.service';

@Component({
  selector: 'app-penzugy-layout',
  templateUrl: './penzugy-layout.component.html',
  styleUrls: ['./penzugy-layout.component.scss'],
})
export class PenzugyLayoutComponent  implements OnInit {


  menu=5
  urlmatrix=[
    {},{url:"adatszolg"},{url:"szamla"},{url:"beszerzes"},{url:"statisztika"},{url:"egyenleg"},{url:"ertekesit"},{url:"ujbizonylat"},{url:"tandij"},{url:"normativa"}
  ]

  sajatIntezmeny
  htmlContent: string = '';
  egyenleg
  loginmode

  /*  CSALÁDI NÉZET: gondviselő VAGY a saját nevében belépő tanuló.
   *
   *  A pénzügy a CSALÁD nyilvántartása. A tanulói belépést eddig semmi nem
   *  kezelte, ezért mindenhol az „egyébként" ág futott – az intézményi nézet,
   *  adminisztrátori műveletekkel. Egy helyen dől el, hogy ki számít családnak.
   */
  get csaladiNezet(): boolean {
    return this.loginmode === 'gondviselo' || this.loginmode === 'tanulo';
  }

  /**
   *  A belső fülek NEM szerepkörre vannak drótozva, hanem az access-táblára: minden fül
   *  akkor látszik, ha a felhasználó jogköre megkapta az adott url-t. Így a szülő a
   *  saját bizonylatait és egyenlegét látja, a bizonylat-kiállítást viszont nem – és
   *  mindez a Jogosultságok szerkesztőből állítható, kódmódosítás nélkül.
   *
   *  A lista alapból ÜRES: amíg a jogosultság meg nem jött, nem mutatunk fület (a
   *  korábbi „nem gondviselő" feltétel a betöltés első pillanatában mindenkire igaz
   *  volt, ezért a szülőnek is felvillantak az adminisztrátori fülek).
   */
  readonly FULEK = [
    { menu: 5, url: '/penzugy/egyenleg',    cim: 'Egyenleg',      ikon: 'assets/icon/icons8-payment-history-96.png' },
    { menu: 2, url: '/penzugy/szamla',      cim: 'Bizonylatok',   ikon: 'assets/icon/icons8-money-96.png' },
    { menu: 7, url: '/penzugy/ujbizonylat', cim: 'Új bizonylat',  ikon: 'assets/icon/icons8-invoice-96.png' },
    { menu: 6, url: '/penzugy/ertekesit',   cim: 'Értékesítés',   ikon: 'assets/icon/icons8-pos-96.png' },
    { menu: 8, url: '/penzugy/tandij',      cim: 'Támogatás',        ikon: 'assets/icon/icons8-cash-in-hand-96.png' },
    { menu: 9, url: '/penzugy/normativa',   cim: 'Normatíva',     ikon: 'assets/icon/icons8-money2-96.png' },
  ];
  lathatoFulek: any[] = [];

  constructor(private data:DataService,private router: Router, private http: HttpClient) { }

  async ngOnInit() {
    this.sajatIntezmeny = (await this.data.getFromStorage("sajatIntezmeny"))

    // Az egyenleg OBJEKTUMKÉNT van a tárolóban (a HttpClient már feloldotta a JSON-t),
    // ezért a régi `JSON.parse(...)` kivételt dobott ("[object Object]" is not valid JSON),
    // és az ngOnInit ITT megszakadt. Emiatt a `loginmode` sosem töltődött be – a belső
    // menü feltétele („nem gondviselő") így a szülőnél is teljesült, a jogosultság-alapú
    // betöltés pedig egyáltalán nem futott le.
    const nyersEgyenleg = await this.data.getFromStorage("egyenleg");
    this.egyenleg = this.egyenlegErtek(nyersEgyenleg);

    this.loginmode = (await this.data.getFromStorage("loginmode"))

    // Szülő (gondviselő) és a saját nevében belépő tanuló: az egyesített
    // Egyenleg nézet nyílik elsőként – a pénzügy a család nyilvántartása.
    if (this.csaladiNezet) {
      this.menu = 5;
    }

    try {
      const jogkor = await this.data.getJogkor();
      const engedett = await Promise.all(
        this.FULEK.map((f) => this.data.canIAccess(jogkor, f.url).catch(() => false)));
      /*  A Tandíj fül csak akkor, ha a NAPLO-ban be van kapcsolva (SULINFORM-összekötés +
       *  tandíj-bankszámla) – különben üres oldalra vinne. */
      const tandijAktiv = engedett[this.FULEK.findIndex((f) => f.menu === 8)]
        ? await this.tandijAktiv() : false;
      /*  A Normatíva fül csak a kezelőnek (könyvelő, „Normatíva”/„Tandíj” admin) – a
       *  hozzáférési sor a Tandíjjal együtt jön, a döntést a kiszolgáló hozza. */
      const normativaKezelo = engedett[this.FULEK.findIndex((f) => f.menu === 9)]
        ? await this.normativaKezelo() : false;
      this.lathatoFulek = this.FULEK.filter((f, i) => engedett[i]
        && (f.menu !== 8 || tandijAktiv) && (f.menu !== 9 || normativaKezelo));
    } catch {
      this.lathatoFulek = [];
    }
    //window.location.replace("/admin/importallomany")
    //this.import=4
    //this.menuChange(4)
    //if(window.location.pathname.indexOf("admin/import") != -1)
    
    //console.log(this.sajatIntezmeny)
  }

  private async tandijAktiv(): Promise<boolean> {
    try {
      const intez = String(this.sajatIntezmeny?.intezmenyId || '').replace(/^\/+|\/+$/g, '');
      const r: any = await firstValueFrom(this.http.get(`/api/tandij/allapot/${intez}`));
      return !!r?.aktiv;
    } catch { return false; }
  }

  private async normativaKezelo(): Promise<boolean> {
    try {
      const intez = String(this.sajatIntezmeny?.intezmenyId || '').replace(/^\/+|\/+$/g, '');
      const r: any = await firstValueFrom(this.http.get(`/api/normativa/allapot/${intez}`));
      return !!r?.kezelheti;
    } catch { return false; }
  }

  /** A tárolóban objektum és (régebbi mentésekből) szöveg is lehet – mindkettőt elfogadjuk. */
  private egyenlegErtek(nyers: any) {
    if (typeof nyers !== 'string') return nyers || null;
    try { return JSON.parse(nyers); } catch { return null; }
  }

  openComponent(c){

  }

  menuChange(n){
    this.menu=n

 
  //window.history.replaceState({}, '', "/admin/"+this.urlmatrix[n][x].url)
  this.router.navigateByUrl("/penzugy/"+this.urlmatrix[n].url);
  //console.log(this.urlmatrix[n][x].url)
  

  
  }

}
